import React, { useEffect, useState } from "react";
import { useAtomValue } from "../app-jotai";
import { cloudSaveStatusAtom } from "./auth-state";
import "./CloudSaveNotification.scss";

export const CloudSaveNotification: React.FC = () => {
  const cloudSaveStatus = useAtomValue(cloudSaveStatusAtom);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (cloudSaveStatus.status === "saved" && cloudSaveStatus.message) {
      setVisible(true);
      const timer = window.setTimeout(() => {
        setVisible(false);
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, [cloudSaveStatus]);

  if (!visible || !cloudSaveStatus.message) {
    return null;
  }

  return (
    <aside
      aria-label="Cloud Save Notification"
      className="CloudSaveNotification"
      onClick={() => setVisible(false)}
    >
      <span className="CloudSaveNotification__indicator" />
      <span className="CloudSaveNotification__text">
        {cloudSaveStatus.message}
      </span>
    </aside>
  );
};
